import { NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { BcStartupModule } from '@beecore/startup';
import { MatIconModule } from '@angular/material/icon';
import { BC_APPLICATION_ID } from '@beecore/core';
import { FA_INITIALIZER_PROVIDER } from './initializers/fa.initializer';
import { SFE_INITIALIZER_PROVIDER } from './initializers/sfe.initializer';
import { HttpClientModule } from '@angular/common/http';
import { BC_SIDEBAR_LOGO_TOKEN, BC_PAGE_LAYOUT_CONFIG_TOKEN, IPageLayoutConfig } from '@beecore/mat-template';
import { AuthorizationHandlerProvider, TenantHandlerProvider, ErrorHandlerProvider, ResponseHandlerProvider, BcApiModule } from '@beecore/api';
import localeBr from '@angular/common/locales/br';
import { SFE_BOOTSTRAP_PROVIDER } from './initializers/sfe.bootstrap';
import { BcAuthModule, BC_LOGIN_STRATEGY_TOKEN } from '@beecore/auth';
import { SfeLoginService } from '../shared/services/sfe-login.service';

registerLocaleData(localeBr, 'br');
const pageLayoutConfig: IPageLayoutConfig = {
  brandTitle: 'Portal SFE',
  brandUri: ''
};

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatIconModule,
    BcStartupModule,
    HttpClientModule,
    BcApiModule,
    BcAuthModule
  ],
  providers: [
    { provide: BC_APPLICATION_ID, useValue: 0 },
    { provide: BC_SIDEBAR_LOGO_TOKEN, useValue: '/assets/logo/logo_color.png' },
    { provide: BC_PAGE_LAYOUT_CONFIG_TOKEN, useValue: pageLayoutConfig },
    { provide: BC_LOGIN_STRATEGY_TOKEN, useClass: SfeLoginService },
    FA_INITIALIZER_PROVIDER,
    SFE_INITIALIZER_PROVIDER,
    SFE_BOOTSTRAP_PROVIDER,
    // Interceptors...
    AuthorizationHandlerProvider,
    TenantHandlerProvider,
    ErrorHandlerProvider,
    ResponseHandlerProvider // This must be the last interceptor...
    // Admin Pages
    // ADM_ABP_APPLICATION_INITIALIZER_PROVIDER,
    // ADM_ABP_AUDIT_INITIALIZER_PROVIDER,
    // ADM_ABP_COMPANY_INITIALIZER_PROVIDER,
    // ADM_ABP_ORGANIZATION_UNIT_INITIALIZER_PROVIDER,
    // ADM_ABP_ROLE_INITIALIZER_PROVIDER,
    // ADM_ABP_TENANT_INITIALIZER_PROVIDER,
    // ADM_ABP_USER_INITIALIZER_PROVIDER
  ],
  exports: [
    MatIconModule
  ]
})
export class StartupModule { }
